import { createSelector } from '@reduxjs/toolkit';
import { Adapter } from 'client/voladeum/adapters/types';
import { RootState } from 'store';

const adaptersSlice = (state: RootState) => state.adapters;

export const selectAdapters = createSelector([adaptersSlice], (state): Adapter[] => state);
